import { api } from './api';
import { toQueryString } from 'utils';
import {
  validateReservationEngineVersion,
  validateReservationEngineVersionMultiUrl,
} from '../../utils/utils';

export const fetchAllAggregates = (params) => {
  const url = validateReservationEngineVersion(`/vehicle_group/aggregates`);
  return api.get(url, params);
};

export const fetchAllAggregatesTotals = (params) => {
  const url = validateReservationEngineVersion(`/vehicle_group/aggregates/totals`);
  return api.get(url, params);
};

export const fetchUsages = (vehicleGroupId, params) => {
  return api.get(`/vehicle_group/${vehicleGroupId}/usage`, params);
};

export const fetchVehicleUsages = (params) => {
  const _params = toQueryString(params);
  const urls = {
    V1: `/vehicle/usage${_params}`,
    V2: `rem/reservation/calendar${_params}`,
  };

  const url = validateReservationEngineVersionMultiUrl(urls);
  return api.get(url);
};
